<template>
	<ProcessCreatePage>
		<Header :title="title" />

		<div class="main text-left">
			<label v-html="message"></label>
		</div>

		<Footer v-if="isError" @backButtonClick="$emit('previous', $event)" :is-skippable="false" :is-continue-button="false">
			<template #right>
				<BaseButton @click="submit" class="mr-4 btn-blue">{{ $t('repeat') }}</BaseButton>
			</template>
		</Footer>
	</ProcessCreatePage>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import Header from '@/components/damagecases/Header';
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Footer from '@/components/damagecases/Footer';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'Submit',
	components: { ProcessCreatePage, Footer, Header, BaseButton },
	mixins: [LoadingSpinner],
	data() {
		return {
			isError: false,
		};
	},
	computed: {
		title() {
			if (this.damageCase.id != null) {
				return !this.isError ? this.$t('damage_case_forms_being_stored').toString() : this.$t('damage_case_forms_store_error').toString();
			} else {
				return !this.isError ? this.$t('damage_case_being_stored').toString() : this.$t('damage_case_store_error').toString();
			}
		},
		message() {
			return !this.isError ? this.$t('please_wait').toString() : this.$t('check_input_and_repeat').toString();
		},
	},
	props: {
		isShown: { default: false, type: Boolean },
		damageCase: {},
	},
	watch: {
		isShown: function() {
			if (this.isShown) {
				this.submit();
			}
		},
	},
	methods: {
		toDamageCase() {
			this.$router.push({
				name: 'management.process.edit',
				params: { processId: this.damageCase.id, customer: this.damageCase.customer.id, scrollToDocs: 'save_documents' },
			});
		},
		submit: function() {
			this.setLoadingStatus(true);
			if (this.damageCase.id != null) {
				DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.damagecasesIdPut(this.damageCase.id, this.damageCase)
					.then(res => {
						this.$emit('next', { customer: res.data.customer, id: res.data.id, imd_net: res.data.imdNetId, pdfUuids: res.data.pdfUuids });
						this.setLoadingStatus(false);
					})
					.catch(error => {
						this.setLoadingStatus(false);
						this.$swal(this.$t('general.error').toString(), this.$t('form_generation_error').toString(), 'error');
						this.isError = true;
					});
			} else {
				DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.createDamageCases({
						...this.damageCase,
						lawyerOffice: this.damageCase.lawyerOffice?.name ? this.damageCase.lawyerOffice : undefined,
					})
					.then(res => {
						this.damageCase.id = res.data.data.id;
						this.damageCase.customer = res.data.data.customer;
						this.setLoadingStatus(false);
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('damage_case_saved').toString(), 'success').then(_ => {
							this.toDamageCase();
						});
					})
					.catch(error => {
						this.setLoadingStatus(false);
						this.$swal(this.$t('general.error').toString(), this.$t('damage_case_save_error').toString(), 'error');
						this.isError = true;
					});
			}
		},
	},
};
</script>
